import {
    createContext, useEffect, useMemo, useState,
} from "react";
import { useParams } from "react-router-dom";
import Preloader from "../../components/Preloader";
import { useGetStudents } from "../../hooks/useGetStudents";
import { useGetSingleStudent } from "../../hooks/useGetSingleStudent";
import { useGetAlumni } from "../../hooks/useGetAlumni";

const StudentsContext = createContext(undefined);

const { Provider } = StudentsContext;

const StudentsProvider = ({ children }) => {
    const {
        isLoading, isRefetching, students, refetch,
    } = useGetStudents();
    const {
        isLoading: isLoadingAlumni, isRefetching: isRefetchingAlumni, alumni, refetch: refetchAlumni,
    } = useGetAlumni();
    const { studentId } = useParams();

    const [activeStudentId, setActiveStudent] = useState(studentId || students?.[0]?.studentId);

    const {
        student, isLoading: isLoadingStudent, isRefetching: isRefetchingStudent, refetch: refetchStudent,
    } = useGetSingleStudent(activeStudentId);

    const value = useMemo(() => {
        const activeStudentFromList = [...students, ...alumni].find((student) => student.studentId === activeStudentId) || {};
        const activeStudent = { ...activeStudentFromList, ...student };

        return {
            students,
            activeStudentId,
            activeStudent,
            permissions: activeStudent?.permissions,
            onChangeActiveStudentId: setActiveStudent,
            refetchStudents: refetch,
            refetchStudent,
            isRefetching: isRefetching || isRefetchingStudent,
            isLoadingStudent,
            alumni,
            isLoadingAlumni,
            isRefetchingAlumni,
            refetchAlumni,
        };
    }, [
        students, activeStudentId, refetch, refetchStudent,
        student, isRefetching, isLoadingStudent, isRefetchingStudent,
        alumni, isLoadingAlumni, isRefetchingAlumni, refetchAlumni,
    ]);

    return (
        <Preloader isLoading={isLoading || isLoadingStudent || isLoadingAlumni}>
            <Preloader isLoading={isRefetching || isRefetchingStudent || isRefetchingAlumni} overflow showInitiallyOverflow>
                <Provider value={value}>
                    {children}
                </Provider>
            </Preloader>
        </Preloader>
    );
};

export {
    StudentsProvider,
    StudentsContext,
};
